import React from 'react';
import Video from './Video';
import Form from './Form';
import Sidenav from './Sidenav';
import Agent from './Agent';
import RelatedVideos from '../components/RelatedVideos';

function VideoFormContainer(props) {
    const styles = (props.styles && typeof props.styles === 'object') ? props.styles : {};
    let videoTitle = null;
    let videoDesc = null;
    let videoObj = null;
    let formObj = null;
    let finalOutput = null;
    let sectionStyle = null;
    let clsname = null;
    let vidDescHtml = props.video.description;
    let checkLinkButton = false;
    let isVideoPortrait = props.video.video_orientation === 'P' ? 'video_portrait' : '';
    
    //let vTitle = null

    let isMobile = false;
    if (/Android|webOS|iPhone|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) ||
        (('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
            !(/iPad/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)))) {
        isMobile = true;
    }

    //let vTitle = props.video.main_title ? props.video.main_title : props.video.title;
    //let vTitle = props.video.main_title ? props.video.main_title : '';
    // let vTitle = props.video.main_title ? props.video.main_title : '' ? props.video.title : props.video.title;
    let vTitle = props.video.title;



    // let agentCity = props.agent.city;
    // let agentState = props.agent.state;

    //     if(props.video.stock){
    //          vTitle = vTitle  + " | Stock# " + props.video.stock;
    //     }

    //     if(props.video.vin){
    //         vTitle = vTitle   + " | VIN# " + props.video.vin;     
    //    }

    //    if(agentCity || agentState){
    //         vTitle = vTitle + " - ";
    //    }

    //    if(agentCity){
    //         vTitle = vTitle + agentCity; 
    //     }

    //     if(agentState){
    //         if(agentCity){
    //             vTitle = vTitle + ", ";
    //         }
    //         vTitle = vTitle + agentState;  
    //     }

    //     if(vidDescHtml){
    //         if(agentCity || agentState){
    //             vidDescHtml = vidDescHtml + " - ";
    //        }
    //         if(agentCity){
    //             let cpc = agentCity;
    //             let capuc = cpc.charAt(0).toUpperCase() + cpc.slice(1);
    //             vidDescHtml = vidDescHtml + capuc;     
    //         }

    //         if(agentState){
    //             let cps = agentState;
    //             let capus = cps.charAt(0).toUpperCase() + cps.slice(1);

    //             if(agentCity){
    //                 vidDescHtml = vidDescHtml + ", ";
    //             }
    //             vidDescHtml = vidDescHtml + capus;
    //          }
    //     }

    let form = {
        fields: [
            {
                label: "First Name",
                name: "firstName",
                type: "text",
                value: "",
                status: "initial",
                required: true,
                rules: null,
                pattern: /^[A-Za-z]/,
                errormsg: "First Name is required!"
            },
            {
                label: "Last Name",
                type: "text",
                name: "lastName",
                required: true,
                rules: null,
                value: "",
                status: "initial",
                pattern: /^[A-Za-z]/,
                errormsg: "Last Name is required!"
            },
            {
                label: "Email Address",
                name: "email",
                type: "email",
                required: true,
                rules: "email",
                status: "initial",
                value: "",
                pattern: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                errormsg: "Valid Email is required!"
            },
            {
                label: "Phone",
                name: "phone",
                type: "text",
                required: false,
                rules: null,
                status: "initial",
                value: "",
                //   pattern : /^(?=.*[0-9])[- +()0-9]+$/,
                pattern: /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/,
                //errormsg :"Valid Phone number is required!"
            },
            {
                label: "Comments",
                name: "maildesc",
                type: "textarea",
                required: false,
                rules: null,
                status: "initial",
                value: "",
                errormsg: "Comments is required!"
            }
        ]
    };
    if (props.template === "LINKED_UP" ||
        props.template === "THEATER" ||
        props.template === "LINKED_UP_LEFT" ||
        props.template === "LINKED_UP_LEFT_FOOTER" ||
        props.template === "THEATER_FOOTER" ||
        props.template === "NEWSLETTER" ||
        props.template === "NEWSLETTER_FOOTER" ||
        props.template === "TABBED_THEATER" ||
        props.template === "TABBED_THEATER_FOOTER" ||
        props.template === "THEATER_NO_SOCIAL") {
        form = {};
        form.fields = [];
    }
    if (props.template === "CROSSBAR" ||
        props.template === "CROSSBAR_FOOTER" ||
        props.template === "CROSSBAR_LEFT_FOOTER" ||
        props.template === "CROSSBAR_LEFT") {
        clsname = "temp2325";
    }

    if (props.video.title) {
        //     let vt = props.video.title;

        //     if(props.agent.city || props.agent.state){
        //         vt = vt + " - ";
        //    }

        //     if(props.agent.city){
        //         vt = vt + props.agent.city;
        //    }

        //    if(props.agent.state){
        //        if(props.agent.city){
        //         vt = vt + ", ";
        //        }
        //        vt = vt + props.agent.state;
        //     }

        videoTitle = <h4 className="main-video-title">{vTitle} </h4>;
    }

    let showDescLength = 200;

    if (props.video.description && !(props.template === "NEWSLETTER") && !(props.template === "NEWSLETTER_FOOTER")) {

        let showMoreLinkDispaly = null;
        let showCloseLinkDisplay = null;

        if (props.video.description.length > showDescLength) {

            let vidDesc = "";

            if (!props.showShortDesc) {
                vidDesc = vidDescHtml.substr(0, showDescLength) + "...";
                showMoreLinkDispaly = {
                    display: "block"
                }
                showCloseLinkDisplay = {
                    display: "none"
                }
            } else {
                vidDesc = vidDescHtml;
                showMoreLinkDispaly = {
                    display: "none"
                }
                showCloseLinkDisplay = {
                    display: "block"
                }
            }

            videoDesc = <React.Fragment>
                <div id="video-desc"><div dangerouslySetInnerHTML={{ __html: vidDesc }} ></div></div>
                <a onClick={props.handleExpandText} className={clsname} style={showMoreLinkDispaly}
                    id="expand-text" href="#0">Show more</a>
                <a onClick={props.handleExpandText} className={clsname} style={showCloseLinkDisplay}
                    id="expand-text" href="#0">Close</a>
            </React.Fragment>
        } else {
            videoDesc = <div id="video-desc"><div dangerouslySetInnerHTML={{ __html: vidDescHtml }} ></div></div>
        }
    } else {
        videoDesc = <div id="video-desc"><div dangerouslySetInnerHTML={{ __html: vidDescHtml }} ></div></div>
    }



    if (props.template === "THEATER"
        || props.template === "THEATER_CONTACT"
        || props.template === "THEATER_CONTACT_FOOTER"
        || props.template === "THEATER_360_FOOTER"
        || props.template === "THEATER_FOOTER"
        || props.template === "NEWSLETTER"
        || props.template === "NEWSLETTER_FOOTER"
        || props.template === "TABBED_THEATER"
        || props.template === "TABBED_THEATER_FOOTER"
        || props.template === "THEATER_NO_SOCIAL") {
        let playerStyle = null;
        if (props.template === "THEATER_CONTACT_FOOTER" || props.template === "THEATER_360_FOOTER") {
            playerStyle = {
                marginTop: "15px"
            }
        }

        videoObj = <React.Fragment>
            <div className="col-sm-12 tabbed_lp player_div" style={playerStyle}>
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} viPlayer={(props.video.viPlayer || props.video.vi_player) !== undefined ? (props.video.viPlayer || props.video.vi_player) : ''} />
            </div>
        </React.Fragment>
        if (props.template === "TABBED_THEATER" || props.template === "TABBED_THEATER_FOOTER") {
            videoObj = <React.Fragment>
                <div className="col-sm-12 tabbed_lp player_div" style={playerStyle}>
                    <Video videoSrc={props.video.tabbed_player} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
                </div>
            </React.Fragment>

        }
    } else if (props.template === "CROSSBAR") {
        let agentNameColor;
        let agentStyle = {
            backgroundColor: "rgb(116, 155, 219)",
            color: "#FFF",
            border: "1px solid rgb(204, 204, 204)",
            position: "relative",
            top: "0",
            paddingLeft: "10px",
            paddingRight: "10px",
        }

        if (styles.agentBox) {
            agentStyle.backgroundColor = styles.agentBox.backgroundColor;
            agentStyle.color = styles.agentBox.color;
        }

        if (styles.agentName) {
            agentNameColor = {
                color: styles.agentName.color
            }
        }

        videoObj = <React.Fragment>
            <div className="col-sm-12 order-1 order-sm-1 col-md-12 order-1 order-md-1 col-lg-8 order-1 order-lg-1 player_div">
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
            </div>
            <div className="col-sm-12 order-4 order-sm-4 col-md-12 order-4 order-md-4" id="video-bottom-agent">
                <Agent agentNameColor={agentNameColor} styles={agentStyle} info={props.agent} preview={props.preview} />
            </div>
        </React.Fragment>

        sectionStyle = {
            backgroundColor: (styles.footerStyle && styles.footerStyle.backgroundColor) || "#FFF",
            color: (styles.footerStyle && styles.footerStyle.color) || "#333",
            paddingTop: "1.5rem"
        }

    } else if (props.template === "CROSSBAR_FOOTER") {
        videoObj = <React.Fragment><div className="col-sm-12 order-1 order-sm-1 col-md-12 order-1 order-md-1 col-lg-8 order-1 order-lg-1 player_div">
            <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
        </div>
        </React.Fragment>
        sectionStyle = {
            backgroundColor: (styles.footerStyle && styles.footerStyle.backgroundColor) || "#FFF",
            color: (styles.footerStyle && styles.footerStyle.color) || "#333",
            paddingTop: "1.5rem"
        }

    } else if (props.template === "CROSSBAR_LEFT") {

        videoObj = <React.Fragment>
            <div className="col-sm-12 col-md-12 col-lg-8 order-xs-1 order-sm-1 order-md-1 order-lg-2 player_div">
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
                <div>
                    {videoTitle}
                    {videoDesc}
                </div>
            </div>

        </React.Fragment>

        sectionStyle = {
            backgroundColor: (styles.headerStyle && styles.headerStyle.backgroundColor) || "#FFF",
            backgroundImage: "url('./images/page-bg.png')",
            backgroundPosition: "top",
            backgroundRepeat: "repeat-x",
            color: (styles.headerStyle && styles.headerStyle.color) || "#333"
        }

        if (props.template === "CROSSBAR_LEFT") {
            sectionStyle.backgroundColor = (styles.footerStyle && styles.footerStyle.backgroundColor) || "#FFF";
            sectionStyle.color = (styles.footerStyle && styles.footerStyle.color) || "#333";
        }
    } else if (props.template === "CROSSBAR_LEFT_FOOTER") {

        videoObj = <React.Fragment>
            <div className="col-sm-12 col-md-12 col-lg-8 order-xs-1 order-sm-1 order-md-1 order-lg-2 player_div">
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
            </div>
        </React.Fragment>

        sectionStyle = {
            backgroundColor: (styles.headerStyle && styles.headerStyle.backgroundColor) || "#FFF",
            backgroundImage: "url('./images/page-bg.png')",
            backgroundPosition: "top",
            backgroundRepeat: "repeat-x",
            color: (styles.headerStyle && styles.headerStyle.color) || "#333"
        }

        if (props.template === "CROSSBAR_LEFT_FOOTER") {
            sectionStyle.backgroundColor = (styles.footerStyle && styles.footerStyle.backgroundColor) || "#FFF";
            sectionStyle.color = (styles.footerStyle && styles.footerStyle.color) || "#333";
        }
    } else if (props.template === "THEATER_CONTACT_FOOTER" || props.template === "THEATER_360_FOOTER") {
        videoObj = <React.Fragment><div className="col-sm-12 player_div">
            <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
        </div>
        </React.Fragment>
    } else if ((!props.links && props.template === "LINKED_UP") || (!props.links && props.template === "LINKED_UP_FOOTER") || (!props.links && props.template === "LP_LINKS_WITH_ICONS")) {
        videoObj = <React.Fragment>
            <div className="col-sm-12 col-md-12 col-lg-12 tabbed_lp player_div">
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
            </div>
        </React.Fragment>
    } else if ((!props.links && props.template === "LINKED_UP_LEFT") || (!props.links && props.template === "LINKED_UP_LEFT_FOOTER")) {
        videoObj = <React.Fragment>
            <div className="col-sm-12 col-md-12 col-lg-12 order-1 order-lg-1 tabbed_lp player_div">
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
            </div>
        </React.Fragment>

    } else if ((props.links && props.template === "LINKED_UP") || (props.links && props.template === "LINKED_UP_FOOTER") || (props.links && props.template === "LP_LINKS_WITH_ICONS")) {
        props.links.map(function (link, index) {
            if (!link.custom_button) {
                checkLinkButton = true;
            }
        });

        if (checkLinkButton) {
            videoObj = <React.Fragment>
                <div className="col-sm-12 col-md-12 col-lg-8 player_div">
                    <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
                </div>
            </React.Fragment>
        } else {
            videoObj = <React.Fragment>
                <div className="col-sm-12 col-md-12 col-lg-12 tabbed_lp player_div">
                    <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
                </div>
            </React.Fragment>
        }
    } else if ((props.links && props.template === "LINKED_UP_LEFT") || (props.links && props.template === "LINKED_UP_LEFT_FOOTER")) {
        props.links.map(function (link, index) {
            if (!link.custom_button) {
                checkLinkButton = true;
            }
        });

        if (checkLinkButton) {
            videoObj = <React.Fragment>
                <div className="col-sm-12 col-md-12 col-lg-8 order-2 order-lg-2 player_div">
                    <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
                </div>
            </React.Fragment>
        } else {
            videoObj = <React.Fragment>
                <div className="col-sm-12 col-md-12 col-lg-12 tabbed_lp player_div">
                    <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
                </div>
            </React.Fragment>
        }
    } else if (props.template === "GET_STARTED"
        || props.template === "GET_STARTED_FOOTER"
        || props.template === "SOCIALIZE"
        || props.template === "SOCIALIZE_FOOTER"
        || props.template === "SIMPLE_FLICKS") {
        videoObj = <React.Fragment>
            <div className="col-sm-12 order-1 order-sm-1 col-md-12 order-1 order-md-1 col-lg-8 order-1 order-lg-1 player_div">
                <Video videoSrc={props.video.source} template={props.template} bodyWidth={props.bodyWidth} isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]} GATrackingId={props.GATrackingId} videoOrientation={props.video.video_orientation != undefined ? props.video.video_orientation : props.video.videoOrientation} />
            </div>
        </React.Fragment>
    }

    if (props.template === "THEATER"
        || props.template === "THEATER_FOOTER"
        || props.template === "NEWSLETTER"
        || props.template === "NEWSLETTER_FOOTER"
        || props.template === "TABBED_THEATER"
        || props.template === "TABBED_THEATER_FOOTER"
        || props.template === "THEATER_NO_SOCIAL") {
        formObj = null;
    } else if (props.template === "THEATER_CONTACT" || props.template === "THEATER_CONTACT_FOOTER") {

        formObj =
            <div className="col-sm-12" id="form-div">
                <Form frm={form}
                    lpForm={props.lpForm}
                    template={props.template}
                    styles={props.styles}
                    shareurl={props.shareurl}
                    dealerName={props.dealerName}
                    preview={props.preview}
                    disclaimer={props.disclaimer}
                />
            </div>;

    } else if (props.template === "THEATER_360_FOOTER") {

        formObj = "";

    } else if ((!props.links && props.template === "LINKED_UP")
        || (!props.links && props.template === "LINKED_UP_FOOTER")
        || (!props.links && props.template === "LINKED_UP_LEFT")
        || (!props.links && props.template === "LINKED_UP_LEFT_FOOTER")
        || (!props.links && props.template === "LP_LINKS_WITH_ICONS")) {

        formObj = null;

    } else if ((props.links && props.template === "LINKED_UP")
        || (props.links && props.template === "LINKED_UP_FOOTER")
        || (props.links && props.template === "LINKED_UP_LEFT")
        || (props.links && props.template === "LINKED_UP_LEFT_FOOTER")
        || (props.links && props.template === "LP_LINKS_WITH_ICONS")) {

        props.links.map(function (link, index) {
            if (!link.custom_button) {
                formObj = <div className="col-sm-12 order-3 order-sm-3 col-md-12 order-3 order-md-3 col-lg-4 order-1 order-lg-1" id="form-div">
                    <Sidenav links={props.links}
                        template={props.template}
                        styles={props.styles}
                    />
                </div>;
            }
        });

    } else if (form.fields.length && props.template === "CROSSBAR_LEFT") {

        formObj = <div className="col-sm-12 col-md-12 col-lg-4 order-2 order-md-2 order-lg-1" id="form-div">

            <Form agent={props.agent}
                lpForm={props.lpForm}
                frm={form}
                template={props.template}
                styles={props.styles}
                shareurl={props.shareurl}
                dealerName={props.dealerName}
                preview={props.preview}
                disclaimer={props.disclaimer}
            />
        </div>;

    } else if (form.fields.length && props.template === "CROSSBAR_LEFT_FOOTER") {


        formObj = <div className="col-sm-12 order-3 order-sm-3 col-md-12 order-3 order-md-3 col-lg-4 order-2 order-lg-2" id="form-div">

            <Form agent={props.agent}
                lpForm={props.lpForm}
                frm={form}
                template={props.template}
                styles={props.styles}
                shareurl={props.shareurl}
                dealerName={props.dealerName}
                preview={props.preview}
                disclaimer={props.disclaimer}
            />
        </div>;

    } else if (form.fields.length && props.template === "CROSSBAR") {

        formObj = <div className="col-sm-12 order-5 order-sm-5 col-md-12 order-5 order-md-5 col-lg-4 order-2 order-lg-2 form-temp-23" id="form-div">

            <Form frm={form}
                lpForm={props.lpForm}
                template={props.template}
                styles={props.styles}
                dealerName={props.dealerName}
                shareurl={props.shareurl}
                disclaimer={props.disclaimer}
            />
        </div>;

    } else if (form.fields.length && props.template === "CROSSBAR_FOOTER") {



        formObj = <div className="col-sm-12 order-3 order-sm-3 col-md-12 order-3 order-md-3 col-lg-4 order-2 order-lg-2" id="form-div">

            <Form frm={form}
                lpForm={props.lpForm}
                template={props.template}
                styles={props.styles}
                shareurl={props.shareurl}
                dealerName={props.dealerName}
                preview={props.preview}
                disclaimer={props.disclaimer}
            />
        </div>;
    } else if ((form.fields.length && props.template === "SOCIALIZE")
        || (form.fields.length && props.template === "SOCIALIZE_FOOTER")) {
        // code from anand
        const formStyle = {
            color: '#fff',
        };

        function handleLableChange(label) {
            document.getElementById("formLabelForLanguageChange").innerText = label;
        }
        formObj = <div className="col-sm-12 order-3 order-sm-3 col-md-12 order-3 order-md-3 col-lg-4 order-1 order-lg-1">
            <div className="form-style-block" id="form-div">
                <div className="form-title">
                    <span className="labeler" id="formLabelForLanguageChange">Get in touch with us</span>
                </div>
                <div className="tri1"></div>
                <Form frm={form}
                    lpForm={props.lpForm}
                    template={props.template}
                    styles={formStyle}
                    shareurl={props.shareurl}
                    dealerName={props.dealerName}
                    preview={props.preview}
                    handleLableChange={handleLableChange}
                    disclaimer={props.disclaimer} />

            </div>



        </div>;
        //end
    } else {



        formObj = <div className="col-sm-12 order-3 order-sm-3 col-md-12 order-3 order-md-3 col-lg-4 order-1 order-lg-1" id="form-div">

            <Form agent={props.agent}
                lpForm={props.lpForm}
                frm={form}
                template={props.template}
                styles={props.styles}
                shareurl={props.shareurl}
                dealerName={props.dealerName}
                preview={props.preview}
                disclaimer={props.disclaimer}
            />
        </div>;
    }
    
    finalOutput = <section style={sectionStyle} className={`video-form ${isVideoPortrait}`} >
        <section className="container mt-3">
            <div className="row">
                {videoObj}
                {formObj}
                <div className="col-sm-12 order-2 order-sm-2 col-md-12 order-2 order-md-2 order-1 order-lg-1">
                    {videoTitle}
                    {videoDesc}
                </div>
            </div>
        </section>
    </section>;

    if (props.template === "LINKED_UP_LEFT"
        || props.template === "LINKED_UP_LEFT_FOOTER") {
        finalOutput = <section style={sectionStyle} className={`video-form ${isVideoPortrait}`}>
            <section className="container mt-3">
                <div className="row">
                    {formObj}
                    {videoObj}
                    <div className="col-sm-12 order-2 order-sm-2 col-md-12 order-2 order-md-2 col-lg-12">
                        {videoTitle}
                        {videoDesc}
                    </div>
                </div>
            </section>
        </section>;
    }
    // code by anand

    if (props.template === "CROSSBAR"
        || props.template === "CROSSBAR_FOOTER") {
        finalOutput = <section style={sectionStyle} className={`video-form ${isVideoPortrait}`}>
            <section className="container mt-3">
                <div className="row">
                    {formObj}
                    {videoObj}
                    <div className="col-sm-12 order-2 order-sm-2 col-md-12 order-2 order-md-2 col-lg-12">
                        {videoTitle}
                        {videoDesc}
                    </div>
                </div>
            </section>
        </section>;
    }

    if (props.template === "CROSSBAR_LEFT") {
        finalOutput = <section style={sectionStyle} className={`video-form ${isVideoPortrait}`}>
            <section className="container mt-3">
                <div className="row">
                    {formObj}
                    {videoObj}
                </div>
            </section>
        </section>;
    } else if (props.template === "CROSSBAR_LEFT_FOOTER") {

        finalOutput = <section style={sectionStyle} className={`video-form ${isVideoPortrait}`}>
            <section className="container mt-3">
                <div className="row">
                    {formObj}
                    {videoObj}
                    <div className="col-sm-12 order-2 order-sm-2 col-md-12 order-2 order-md-2 col-lg-12">
                        {videoTitle}
                        {videoDesc}
                    </div>
                </div>
            </section>
        </section>;
    }
    
    if (props.template === "THEATER_CONTACT"
        || props.template === "THEATER_CONTACT_FOOTER") {

        let carfaxImage = <a target="_blank" href="https://www.carfax.com/vehiclehistory/ar20/G_8JkkjCOXr6IRDhJD8_-0SnTk3hZ-1-4NYWm5OOZohdL-ZCotvXlNXruYC9SEQhpF388yCZ5w0piBf7CDVBxG5feSOBCSkN8Wg"><img src='/NLP/build/images/carfax-logo.png' /></a>;

        finalOutput = <section style={sectionStyle} className={props.viPlayer === "1" ? `ece_active video-form ${isMobile ? 'mobile_active' : ''}` : `video-form ${isVideoPortrait}`}>
            <section className="container">
                <div className="row">
                    {videoObj}
                    {
                        
                        (props.viPlayer === "1" && props.video.video_fk === 'B8E9C513-1DFC-410F-BAF5-EC16BB6A27A9') ? (
                            <div className=' ol-sm-12 col-md-12 col-lg-12'>
                                <div className='carfax-container'>
                                    {
                                        isMobile ? carfaxImage : ''
                                    }
                                    <div>{videoTitle} {videoDesc}</div>
                                    {
                                        !isMobile ? carfaxImage : ''
                                    }
                                </div>

                            </div>
                        ) :
                            (
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    {videoTitle} {videoDesc}
                                </div>
                            )
                    }
                    {formObj}
                </div>
            </section>
        </section>;
    }


    if (props.template === "SOCIALIZE" || props.template === "SOCIALIZE_FOOTER") {
        finalOutput = <section className="container-fluid videopart-bg">
            <section style={sectionStyle}>
                <section className="container mt-3 py-4 ">
                    <div className="row socialize_custom_div">
                        {videoObj}
                        {formObj}
                        <div className="col-sm-12 order-2 order-sm-2 col-md-12 order-2 order-md-2 order-1 order-lg-1">
                            {videoTitle}
                            {videoDesc}
                        </div>
                    </div>
                </section>
            </section>
        </section>;
    }
    if (props.template === "NEWSLETTER" || props.template === "NEWSLETTER_FOOTER") {
        let videoTitle = <div className="col-sm-12"><h4 className="main-video-title-top">{vTitle}</h4></div>;
        return (
            <section className="container">
                <div className="row">
                    {videoTitle}
                    {videoObj}
                    <div className="col-sm-12">
                        {/* <div dangerouslySetInnerHTML={{__html: props.video.description}} ></div> */}
                        <div dangerouslySetInnerHTML={{ __html: vidDescHtml }} ></div>
                    </div>
                </div>
            </section>
        );
    }
    if (props.template === "TABBED_THEATER" || props.template === "TABBED_THEATER_FOOTER") {
        let container = {
            maxWidth: "960px"
        }

        if (props.template === "TABBED_THEATER_FOOTER") {
            container = {
                marginTop: "30px",
                maxWidth: "960px"
            }
        }
        return (
            <section className="container" style={container}>
                <div className="row">
                    {videoObj}
                    <div className="col-sm-12">
                        {videoTitle}
                        {videoDesc}
                    </div>
                </div>
            </section>
        );
    }
    if (props.template === "VT_VIDEO_RV" ||
        props.template === "VT_VIDEO_FORM" ||
        props.template === "VT_VIDEO_FORM_RV") {

        const videoOrientation = (props.video && (props.video.video_orientation || props.video.videoOrientation)) || props.videoOrientation || '';
        const isPortrait = props.isPlayerPortrait === true;

        const videoComponent = (
            <Video
                videoSrc={props.video.source}
                template={props.template}
                bodyWidth={props.bodyWidth}
                isPano={(props.video["360_player"] === undefined) ? props.video["isPlayerPano"] : props.video["360_player"]}
                GATrackingId={props.GATrackingId}
                videoOrientation={videoOrientation}
                isPlayerPortrait={isPortrait}
                reportVideoOrientation={props.reportVideoOrientation}
                viPlayer={(props.video.viPlayer || props.video.vi_player) !== undefined ? (props.video.viPlayer || props.video.vi_player) : ''}
            />
        );

        const relatedVideosComponent = (
            <RelatedVideos
                baseurl={props.baseUrl}
                preview={props.preview}
                handleLoadVideo={props.handleLoadVideo}
                template={props.template}
                vidkey={props.vidkey}
                video_fk={props.video.video_fk}
                vehicleFkey={props.vehicleFkey}
                backgroundImageVal={props.backgroundImageVal}
                viPlayer={props.viPlayer}
            />
        );

        const formComponent = (
            <Form
                frm={form}
                lpForm={props.lpForm}
                styles={props.styles}
                shareurl={props.shareurl}
                dealerName={props.dealerName}
                preview={props.preview}
                disclaimer={props.disclaimer}
                template={props.template}
                backgroundImageVal={props.backgroundImageVal}
            />
        );

        if (props.template === "VT_VIDEO_RV") {
            return (
                <section className={`container-fluid vt-main-section ${isPortrait ? 'vt-portrait video_portrait' : ''}`}>
                    <div className={`container vt-container ${isPortrait ? 'vt-portrait video_portrait' : ''}`} id="main-widget-areaplayer">
                        <div className="row">
                            <div className="col-12 vt-player-col">
                                <div className={`vt-video-wrapper ${isPortrait ? 'vt-portrait-wrapper' : ''}`}>
                                    {videoComponent}
                                </div>
                            </div>
                            <div className="col-12 vt-rv-col">
                                {relatedVideosComponent}
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        if (props.template === "VT_VIDEO_FORM") {
            return (
                <section className={`container-fluid vt-main-section ${isPortrait ? 'vt-portrait video_portrait' : ''}`}>
                    <div className={`container vt-container ${isPortrait ? 'vt-portrait video_portrait' : ''}`} id="main-widget-areaplayer">
                        <div className={`row vt-video-form-row ${isPortrait ? 'vt-portrait-row' : ''}`}>
                            <div className="col-12 col-md-12 col-lg-8 vt-player-col">
                                <div className={`vt-video-wrapper ${isPortrait ? 'vt-portrait-wrapper' : ''}`}>
                                    {videoComponent}
                                </div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-4 vt-form-col">
                                <div className="vt-form-card">
                                    {formComponent}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        if (props.template === "VT_VIDEO_FORM_RV") {
            return (
                <section className={`container-fluid vt-main-section ${isPortrait ? 'vt-portrait video_portrait' : ''}`}>
                    <div className={`container vt-container ${isPortrait ? 'vt-portrait video_portrait' : ''}`} id="main-widget-areaplayer">
                        <div className={`vt-grid-layout ${isPortrait ? 'vt-portrait-grid' : ''}`}>
                            <div className="vt-area-video">
                                <div className={`vt-video-wrapper ${isPortrait ? 'vt-portrait-wrapper' : ''}`}>
                                    {videoComponent}
                                </div>
                            </div>
                            <div className="vt-area-form">
                                <div className="vt-form-card">
                                    {formComponent}
                                </div>
                            </div>
                            <div className="vt-area-rv">
                                {relatedVideosComponent}
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    }
    return (
        finalOutput
    );
}

export default VideoFormContainer;



// WEBPACK FOOTER //
// ./src/components/VideoFormContainer.js